import React, { useEffect, useState } from 'react'
import './cookies.scss';
import Cookies from "js-cookie";

export default function Cookie() {
    const [accepctcookie, setAccepctcookie] = useState(false);
    const expireDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
    useEffect(() => {
        const cookiesAccepect = Cookies.get('acceptedCookies');
        if (cookiesAccepect === 'true' || cookiesAccepect === 'false') {
            setAccepctcookie(true);
        }
    }, [])
    const acceptCookies = () => {
        Cookies.set('acceptedCookies', 'true', { expires: expireDate });
        setAccepctcookie('true');
    };

    const rejectCookies = () => {
        Cookies.set('acceptedCookies', 'false', { expires: expireDate });
        setAccepctcookie('false');
    };
    if (accepctcookie) {
        return null;
    }
    const closeBtn = () => {
        setAccepctcookie('false');
    }
    return (
        <div className='cookie_sec'>
            <div className="cookies_Notice">
                <p title="Cookies help us enhance your visit. Click 'Accept' to consent. Learn more in our Privacy Policy.">
                    Cookies help us enhance your visit. Click 'Accept' to consent. Learn
                    more in our <a href="/privacy-policy">Privacy Policy</a>
                </p>
            </div>
            <div className="cookies_Button">
                <div onClick={rejectCookies} title="Reject" className="cookies_Btn Rejected">
                    <button>Reject</button>
                </div>
                <div onClick={acceptCookies} title="Accept" className="cookies_Btn Accpect">
                    <button>Accept</button>
                </div>
                <div title='Close' onClick={closeBtn} className="close_Btn">
                    <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path>
                    </svg>
                </div>
            </div>
        </div>
    )
}
